//这里是 企业产品 模块的路由文件

const basePath = "/admin/enterprise/";
export default [
    //产品分类管理
    {
        path: `${basePath}class`,
        name: 'EnterpriseClass',
        component: r => require.ensure([], () => r(require('@/views/enterprise/EnterpriseClass')), 'Enterprise')
    },
    //产品列表
    {
        path: `${basePath}list`,
        name: 'EnterpriseList',
        component: r => require.ensure([], () => r(require('@/views/enterprise/EnterpriseList')), 'Enterprise')
    },
    //售前邮箱配置
    {
        path: `${basePath}email`,
        name: 'EnterpriseEmail',
        component: r => require.ensure([], () => r(require('@/views/enterprise/EnterpriseEmail')), 'Enterprise')
    }
]
